/**
 * Utility functions for deploy code generation
 */

import { API_KEY_PLACEHOLDER } from "./types";

export function replaceApiKeyPlaceholder(text: string | null, apiKey: string | null): string {
    if (!text || !apiKey) {
        return text || "";
    }
    return text.replaceAll(API_KEY_PLACEHOLDER, apiKey);
}
